import { api } from '../../api/setup';

// Types
interface GraphNode {
  id: string;
  element_id: string;
  name: string;
  labels: string[];
  properties: Record<string, any>;
  n_iteration?: number;
  hs_code?: string[];
  hs_code_description?: string[];
  function?: string;
}

interface GraphRelationship {
  id: string;
  start_node_id: string;
  end_node_id: string;
  type: string;
  properties?: Record<string, any>;
}

interface IncomingRelationship {
  sourceNode: GraphNode | undefined;
  relationship: GraphRelationship;
  relationshipType: string;
  weight: number;
}

interface ApiResponse<T> {
  success: boolean;
  data?: T;
}

export const fullValueChainService = {
  // Fetch available root nodes for selection
  async getAvailableNodes(): Promise<GraphNode[]> {
    const resp: ApiResponse<GraphNode[]> = await api.graphData.getAvailableRootNodesApiV1GraphRootsGet();
    if (resp?.success && resp?.data) return resp.data;
    return [];
  },

  // Fetch graph data for a specific node
  async getGraphData(elementId: string, maxIterations: number = 3, minThreshold?: number): Promise<any> {
    const resp: any = await api.graphData.getIncomingGraphApiV1GraphIncomingElementIdGet(String(elementId), maxIterations, minThreshold);
    if (resp?.success && resp?.data) return resp.data;
    throw new Error('Failed to fetch graph data');
  },

  // Fetch incoming relationships for a specific node
  async getIncomingRelationships(elementId: string, minThreshold?: number): Promise<IncomingRelationship[]> {
    const resp: any = await api.graphData.getIncomingGraphApiV1GraphIncomingElementIdGet(String(elementId), 1, minThreshold);
    if (resp?.success && resp?.data) {
      const data = resp.data;
      const directIncoming = data.relationships
        .filter((rel: any) => rel.end_node_id === elementId)
        .map((rel: any) => {
          const sourceNode = data.nodes.find((node: any) => node.id === rel.start_node_id);
          return {
            sourceNode: sourceNode,
            relationship: rel,
            relationshipType: rel.type,
            weight: rel.properties?.path_weight || 1
          };
        });
      return directIncoming;
    }
    return [];
  }
};

export default fullValueChainService;
